import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import db from "./Firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Moment from "moment";
import { extendMoment } from "moment-range";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ProfileType() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        // Fetch enrolled courses
        const unsubscribe = db.collection("profile_type")
            .orderBy("created_date", "desc")
            .onSnapshot((snapshot) => {
                const courses = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }));
                setData(courses);
            });

        return () => unsubscribe();
    }, []);

    // **Filter Data Based on Search Query**
    const filteredData = data.filter((record) =>
        record.data.profile_type.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // **Export Data to Excel**
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            filteredData.map(({ data }, index) => ({
                "Sr. No": index + 1,
                Name: data.name,
                "Phone No": data.phone_no,
                "Profile Type": data.profile_type,
                "Age Range": data.age_range,
            }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Profile Types");

        // Create and save the Excel file
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "Profile_Types.xlsx");
    };

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3 d-flex justify-content-between">
                    <h6 className="mb-2">Profile Type</h6>
                    <button className="btn btn-success btn-sm" onClick={exportToExcel}>
                        Download Excel
                    </button>
                </div>

                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by Profile Type"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Profile Type</th>
                                <th>Age Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{data.name}</td>
                                    <td>{data.phone_no}</td>
                                    <td>{data.profile_type}</td>
                                    <td>{data.age_range}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default ProfileType;



// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import db from "./Firebase";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import Moment from "moment";
// import { extendMoment } from "moment-range";

// function ProfileType() {
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");

//     useEffect(() => {
//         // Fetch enrolled courses
//         const unsubscribe = db.collection("profile_type")
//             .orderBy("created_date", "desc")
//             .onSnapshot((snapshot) => {
//                 const courses = snapshot.docs.map((doc) => ({
//                     id: doc.id,
//                     data: doc.data(),
//                 }));
//                 setData(courses);// Fetch names after courses are loaded
//             });

//         return () => unsubscribe();
//     }, []);


//     // **Filter Data Based on Search Query**
//     const filteredData = data.filter((record) =>
//         record.data.profile_type.toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     return (
//         <>
//             <div className="p-2 d-flex justify-content-between">
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3">
//                     <h6 className="mb-2">Profile Type</h6>
//                 </div>

//                 <input
//                     type="text"
//                     className="form-control form-control-sm mb-2"
//                     placeholder="Search by Course Name"
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                 />

//                 <div className="table-responsive fix-width scroll-inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Name</th>
//                                 <th>Phone No</th>
//                                 <th>Profile Type</th>
//                                 <th>Age Range</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.map(({ id, data }, index) => (
//                                 <tr key={id}>
//                                     <td>{index + 1}</td>
//                                     <td>{data.name}</td>
//                                     <td>{data.phone_no}</td>
//                                     <td>{data.profile_type}</td>
//                                     <td>{data.age_range}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default ProfileType;